import { DragHandle } from '@atom-learning/icons'
import * as React from 'react'

import { styled } from '~/styled'

import { ActionIcon } from '../action-icon/ActionIcon'
import { Icon } from '../icon/Icon'

export const StyledHandle = styled(ActionIcon, {
  base: [
    'text-inherit!',
    'fill-current',
    'disabled:**:pointer-events-none',
    'disabled:cursor-not-allowed',
    'disabled:opacity-30'
  ],
  variants: {
    isDragging: {
      true: ['cursor-grabbing'],
      false: ['cursor-grab']
    }
  }
})

export type THandleProps = Omit<
  React.ComponentProps<typeof StyledHandle>,
  'children'
> &
  Pick<React.ComponentProps<typeof Icon>, 'size'>

export const Handle = React.forwardRef<HTMLButtonElement, THandleProps>(
  ({ isDragging, size, ...rest }, ref) => {
    return (
      <StyledHandle
        ref={ref}
        isDragging={isDragging}
        appearance="simple"
        hasTooltip={false}
        size={size}
        {...rest}
      >
        <Icon is={DragHandle} />
      </StyledHandle>
    )
  }
)

Handle.displayName = 'Handle'
